import { ACCESS_TOKEN_KEY } from "../common/constants/persistentDataConstants";

export async function fetchWrapper<TBody>(
  input: RequestInfo,
  method: string = "GET",
  body: TBody | null = null,
) {
    const accessToken = sessionStorage.getItem(ACCESS_TOKEN_KEY);

    if (accessToken === null) {
        throw new Error("Invalid access token");
    }

    let response = await fetch(`${process.env.REACT_APP_SERVICE_URL}${input}`, {
        method: method,
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": `Bearer ${accessToken}`,
        },
        body: body ? JSON.stringify(body) : null,
    });

    if (response.status === 401 || response.status === 403) {
        throw new Error("Unauthorized");
    }

    if (!response.ok) {
        throw new Error(`Error ${response.status} ${response.statusText}.`);
    }

    if (response?.headers?.get("content-type")?.includes("application/json")) {
        return response.json();
    }

    return response;
}
